<template>
  <div>
    <el-form
      ref="form"
      size="small"
      :model="formData"
      :rules="rules"
      :disabled="disabled"
    >
      <el-row :gutter="20">
        <el-col :span="4">
          <el-form-item
            :label="
              $l('setting_declaration_isSpecialScm') ||
                '是否指定工厂'
            "
          >
            <br/>
            <el-radio-group v-model="formData.isSpecialScm">
              <el-radio label="Y">{{ $l('INDEX.YES') || '是' }}</el-radio>
              <el-radio label="N">{{ $l('INDEX.NO') || '否' }}</el-radio>
            </el-radio-group>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item
            :label="
              $l('setting_declaration_scmCode') ||
                '工厂'
            "
            prop="scmCode"
          >
            <dict-select
              v-model="formData.scmCode"
              size="small"
              clearable
              filterable
              url="/master/common/dict/scmPartners"
              :disabled="!isSpecialScm"
            ></dict-select>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item
            :label="
              $l(
                'setting_declaration_discountSalesAmount'
              ) || '销售金额是否需要折扣佣金'
            "
          >
            <el-radio-group v-model="formData.discountSalesAmount">
              <el-radio label="Y">{{ $l('INDEX.YES') || '是' }}</el-radio>
              <el-radio label="N">{{ $l('INDEX.NO') || '否' }}</el-radio>
            </el-radio-group>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="10">
        <el-col :span="24">
          <el-form-item
            :label="
              $l('setting_declaration_formula') ||
                '报关金额计算公式'
            "
            prop="formula"
          >
            <el-input
              v-model="formData.formula"
              :placeholder="$l('INDEX.tips_input_placeholder') || '请输入'"
              size="small"
              maxlength="100"
              clearable
            >
            </el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="10">
        <el-col :span="24">
          <el-form-item
            :label="
              $l('setting_declaration_ftyFormula') ||
                '发运通知书工厂金额计算公式'
            "
            prop="ftyFormula"
          >
            <el-input
              v-model="formData.ftyFormula"
              :placeholder="$l('INDEX.tips_input_placeholder') || '请输入'"
              size="small"
              maxlength="100"
              clearable
            >
            </el-input>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
  </div>
</template>
<script>
import validate from '@/libs/util.validate'
import EditLoading from '@/mixins/edit-loading'
export default {
  mixins: [EditLoading],
  props: {
    disabled: Boolean,
    shipmentCustomerSettingCode: {type: String, default: ''},
    declarationSettingCode: {type: String, default: ''},
    params: {type: Object, default: () => {}},
  },
  data() {
    return {
      formData: {isSpecialScm: 'Y', discountSalesAmount: 'Y'},
      isSpecialScm: true,
      rules: {
        formula: [
          {
            required: true,
            message: this.$l('INDEX.tips_input_placeholder') || '请输入',
            trigger: 'blur',
          },
        ],
        ftyFormula: [
          {
            required: true,
            message: this.$l('INDEX.tips_input_placeholder') || '请输入',
            trigger: 'blur',
          },
        ],
        scmCode: [
          {
            required: true,
            message: this.$l('INDEX.tips_select_placeholder') || '请选择',
            trigger: 'change',
          },
        ],
      },
    }
  },
  watch: {
    'formData.isSpecialScm'(){
      if (this.formData.isSpecialScm === 'Y') {
        this.isSpecialScm = true
        this.rules.scmCode[0].required = true
      } else {
        this.isSpecialScm = false
        this.formData.scmCode = null
        this.rules.scmCode[0].required = false
      }
    }
  },
  mounted() {
    this.getData()
  },
  methods: {
    getData() {
      if (!this.declarationSettingCode) return

      this.$api
        .shipmentCustomerSettingDeclarationDetailApi({
          declarationSettingCode: this.declarationSettingCode,
        })
        .then((res) => {
          this.formData = res.body
        })
    },
    async save() {
      const result = await validate.formValidate([this.$refs.form])
      if (!result) {
        return
      }
      this.loadingOpen()
      this.$api
        .shipmentCustomerSettingDeclarationSaveApi({
          ...this.formData,
          shipmentCustomerSettingCode: this.shipmentCustomerSettingCode,
        })
        .then((res) => {
          this.loadingClose()
          this.$message({
            showClose: true,
            message: this.$l('INDEX.tips_save_ok') || res.msg,
            type: 'success',
          })
          this.$emit('close')
          this.$emit('reload')
        })
        .catch(() => {
          this.loadingClose()
        })
    },
    cancel() {
      if (this.disabled) {
        this.close()
        return
      }
      this.openQuestion()
    },
    close() {
      this.$emit('close')
    },
    openQuestion() {
      this.$confirm(
        this.$l('INDEX.tips_question_save') || '是否要保存更改',
        this.$l('INDEX.tips_question_title') || '提示信息',
        {
          distinguishCancelAndClose: true,
          confirmButtonText: this.$l('INDEX.btn_save') || '保存',
          cancelButtonText: this.$l('INDEX.btn_no_save') || '不保存',
        }
      )
        .then(() => {
          this.save()
        })
        .catch((action) => {
          if (action === 'cancel') {
            this.close()
          }
        })
    },
  },
}
</script>
<style scoped>
  .col-margin{
    margin-left: 100px;
  }
</style>